// extracted by mini-css-extract-plugin
export default {"container":"ActuallyOrder_container__zi3QW","icon":"ActuallyOrder_icon__vsVM5"};